// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__u7Ee1","author":"Table_author__FElmY","authorImage":"Table_authorImage__1ocZH","unreadRow":"Table_unreadRow__7UDjy"};